import { FC, useEffect, useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Header from "../layouts/header";
import Footer from "../layouts/footer";
import {
  getInvoiceList,
  getExportList,
} from "../../redux/actions/invoiceAction";
import { AppDispatch } from "../../redux/store";
import YesNoDropdown from "../../components/YesOrNoDropDown";
import Pagination from "../../components/pagination";
import { hasPermission } from "../../config/permissionUtils";
import { usePermissions } from "../../context/PermissionsContext";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Invoice: FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [CurrentPage, setCurrentPage] = useState(1);
  const [pgsize] = useState(10);
  const [invoiceId, setInvoiceId] = useState("");
  const [farmId, setFarmId] = useState("");
  const [state, setState] = useState("");
  const [poketId, setPoketId] = useState("");
  const [status, setStatus] = useState("");
  const [downloaded, setDownloaded] = useState<boolean | null>(null);
  const roleid = localStorage.getItem("roleid") ?? "";
  const { permissions, loading, error } = usePermissions();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [invoiceList, setInvoiceList] = useState({
    data: [],
    pageIndex: 0,
    pageSize: 0,
    totalrecords: 0,
    totalPage: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  });

  useEffect(() => {
    searchInvoice();
  }, [CurrentPage, invoiceId, farmId, state, poketId, status, downloaded]);

  const searchInvoice = () => {
    const payload = {
      PageIndex: CurrentPage,
      PageSize: pgsize,
      SkipRow: pgsize * (CurrentPage - 1),
      SortBy: null,
      SortOrder: "desc",
      invoiceid: invoiceId || null,
      farm_id: farmId || null,
      state: state || null,
      poket_id: poketId || null,
      status: status || null,
      downloaded: downloaded,
    };

    dispatch(
      getInvoiceList(payload, (response: any) => {
        if (response.status !== 500) {
          setInvoiceList(response);
        }
      })
    );
  };

  const handleSearch = () => {
    setCurrentPage(1);
    searchInvoice();
  };

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  return (
    <div>
      <Header />
      <div className="midCon pb-2">
        <section className="pt-4 pb-4">
          <div className="container">
            <div className="d-flex justify-content-between align-items-end">
              <div>
                <div className="loginHd mb-1">
                  <span className="d-block">Invoices</span>
                </div>
                <div className="bradcrumb">
                  <NavLink to="/dashboard">Dashboard</NavLink> &gt; Invoices
                </div>
              </div>
              <div>
                {hasPermission(permissions, roleid, "Farm", "add") && (
                  <button
                    type="button"
                    className="ms-3 formBtn"
                    onClick={() => setIsModalOpen(true)}
                  >
                    Download report
                  </button>
                )}
              </div>
            </div>
          </div>
        </section>

        <ReportDetailsModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />

        <section className="filterCon">
          <div className="container">
            <div className="d-flex flex-wrap align-items-center pt-3 pb-3">
              <div className="searchBy">Search By</div>
              <ul className="d-flex flex-wrap filterBox">
                <li className="col-6 col-sm-3">
                  <div className="position-relative">
                    <span className="field">Farm ID</span>
                    <input
                      type="text"
                      className="filterInput"
                      value={farmId}
                      onChange={(e) => setFarmId(e.target.value)}
                    />
                  </div>
                </li>
                <li className="col-6 col-sm-3">
                  <div className="position-relative">
                    <span className="field">Poket ID</span>
                    <input
                      type="text"
                      className="filterInput"
                      value={poketId}
                      onChange={(e) => setPoketId(e.target.value)}
                    />
                  </div>
                </li>
                <li className="col-6 col-sm-3">
                  <div className="position-relative">
                    <span className="field">Status</span>
                    <input
                      type="text"
                      className="filterInput"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    />
                  </div>
                </li>
                <li className="col-6 col-sm-3">
                  <div className="position-relative">
                    <span className="field">Downloaded</span>
                    <YesNoDropdown
                      name="downloaded"
                      value={downloaded}
                      onChange={(name, value) => setDownloaded(value)}
                    />
                  </div>
                </li>
                <li className="btn">
                  <button type="button" onClick={handleSearch}>
                    <span className="material-icons">search</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section className="pt-4 pb-4 mt-2 whtBg">
          <div className="container">
            <div className="tableBox">
              <table>
                <thead>
                  <tr>
                    <th>Farm ID</th>
                    <th>Poket ID</th>
                    <th>State</th>
                    <th>Status</th>
                    <th>Downloaded</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {invoiceList.data.map((item: any, index: number) => (
                    <tr key={index}>
                      <td>{item.farm_id}</td>
                      <td>{item.poket_id}</td>
                      <td>{item.state}</td>
                      <td>{item.status}</td>
                      <td>{item.downloaded}</td>
                      <td>
                        <div className="actionbtn d-flex">
                          <NavLink
                            to={`/Invoice/view/${item.invoiceid}`}
                            title="View"
                          >
                            <span className="material-icons-outlined">
                              visibility
                            </span>
                          </NavLink>
                          <NavLink
                            to={`/Invoice/edit/${item.invoiceid}`}
                            title="Edit"
                          >
                            <span className="material-icons">edit</span>
                          </NavLink>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between align-items-center pt-3 pb-3">
              <div className="totalResul">{invoiceList.totalrecords}</div>
              <Pagination
                GoToPage={(value: number) => {
                  setCurrentPage(value);
                }}
                PageIndex={Number(invoiceList.pageIndex)}
                TotalPages={Number(invoiceList.totalPage)}
                hasNextPage={Boolean(invoiceList.hasNextPage)}
                hasPreviousPage={Boolean(invoiceList.hasPreviousPage)}
              />
              <div></div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};
export default Invoice;
export { ReportDetailsModal };

const ReportDetailsModal: FC<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [reportStatus, setReportStatus] = useState("");
  const dispatch = useDispatch<AppDispatch>();

  if (!isOpen) return null;

  const handleDownloadReport = async () => {
    const payload = {
      date_from: fromDate,
      date_to: toDate,
      status: reportStatus,
    };

    dispatch(
      getExportList(payload, (response: any) => {
        if (response.statusCode == 1) {
          const headers = [
            "Invoice ID",
            "ID",
            "Name",
            "Latitude",
            "Longitude",
            "State",
            "Username",
            "Timestamp",
            "Task Date",
            "Import Date",
            "Name of Input",
            "Total Cost of Receipt",
            "Only for Enrolled Fields",
            "Task End Timestamp",
            "Survey Version",
            "Image File Name",
            "Status",
            "Downloaded",
          ];

          const excelData = response.data.map((item: any) => [
            item.invoiceid,
            item.id,
            item.name,
            item.latitude,
            item.longitude,
            item.state,
            item.username,
            item.timestamp,
            item.task_date,
            item.import_date,
            item.task_name_of_input,
            item.task_total_cost_of_the_receipt,
            item.task_only_for_enrolled_fields,
            item.task_task_end_timestamp,
            item.task_survey_version,
            item.image_file_name,
            item.status,
            item.downloaded ? "Yes" : "No",
          ]);

          const worksheet = XLSX.utils.aoa_to_sheet([headers, ...excelData]);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

          const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });

          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(
            blob,
            `invoice_report_${new Date().toISOString().split("T")[0]}.xlsx`
          );

          onClose();
        } else {
          alert("No data available for the selected filters.");
        }
      }) as any
    );
  };

  return (
    <div
      className="modal show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Download Report</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div
            className="modal-body"
            style={{ maxHeight: "calc(90vh - 200px)", overflowY: "auto" }}
          >
            <ul className="list-unstyled">
              <li className="mb-3">
                <strong>From Date</strong>
                <input
                  type="date"
                  className="form-control mt-1"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  required
                />
              </li>
              <li className="mb-3">
                <strong>To Date</strong>
                <input
                  type="date"
                  className="form-control mt-1"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  required
                />
              </li>
              <li className="mb-3">
                <strong>Status</strong>
                <select
                  className="form-control mt-1"
                  value={reportStatus}
                  onChange={(e) => setReportStatus(e.target.value)}
                >
                  <option value="">Select Status</option>
                  <option value="NOT_APPROVED">NOT APPROVED</option>
                  <option value="APPROVED">APPROVED</option>
                </select>
              </li>
            </ul>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleDownloadReport}
            >
              Download
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
